export default "__VITE_ASSET__ByYNCcga__"